import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/service/system/authentication.service';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';

declare var require: any;

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})

export class SidenavComponent implements OnInit {

  // Images
  chatImagePath:string = require('../../assets/images/ic_chat.png');
  ovalImagePath:string = require('../../assets/images/Oval.png');
  combinedImagePath:string = require('../../assets/images/ic_combined.png');
  logoImagePath:string = require('../../assets/images/Logo.png');
  currentPath: any = window.location.pathname;
  userDisplayName = '';
  
  constructor(private _authenticationService: AuthenticationService, private adal: MsAdalAngular6Service) {
    console.log("currentPath ", this.currentPath);
    this.userDisplayName = this.adal.userInfo && this.adal.userInfo.profile.name;
  }

  ngOnInit(): void {
    this.userDisplayName = this.adal.userInfo && this.adal.userInfo.profile.name;
  }

  logout(){
    this._authenticationService.logout();
  }

}
